import { Fragment, type ReactNode } from 'react';

export const highlightText = (text: string, keyPrefix: string, searchTerm?: string): ReactNode => {
  if (!searchTerm?.trim()) {
    return text;
  }

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) => {
    if (part && part.toLowerCase() === searchTerm.toLowerCase()) {
      return (
        <span key={`${keyPrefix}-${index}`} className="font-bold">
          {part}
        </span>
      );
    }
    return <Fragment key={`${keyPrefix}-${index}`}>{part}</Fragment>;
  });
};
